import {ProtocolTransformer} from './protocol-transformer';
import {CustomJsonRpcRequest, JsonRpcRequest, JsonRpcResponse, ServerJsonRpcResponse} from '../typings/game-server';
import {InvalidRpcError} from '../errors/invalid-rpc-error';

export class HubApiTransformer<REQ, RESP> implements ProtocolTransformer<REQ, RESP> {
    private deviceIdentifier: string|null;

    constructor(deviceIdentifier: string|null) {
        this.deviceIdentifier = deviceIdentifier;
    }

    public transformRequest(request: JsonRpcRequest<REQ>): CustomJsonRpcRequest<REQ> {
        let transformedReq: CustomJsonRpcRequest<REQ> = {
            ...request,
            params: [request.params]
        };

        if (this.deviceIdentifier) {
            transformedReq = {
                ...transformedReq,
                deviceIdentifier: this.deviceIdentifier
            };
        }

        return transformedReq;
    }

    public transformResponse(rawResponseData: unknown): JsonRpcResponse<RESP> {
        if (!this.isValidProtocol(rawResponseData)) {
            throw new InvalidRpcError('Invalid response protocol');
        }
        
        return this.transformRawResponseData(rawResponseData);
    }

    // eslint-disable-next-line class-methods-use-this
    protected isValidProtocol(responseData: unknown): responseData is ServerJsonRpcResponse<RESP> {
        const requiredFields = ['jsonrpc', 'result'];

        if (typeof responseData !== 'object' || !responseData) {
            return false;
        }

        for (const field of requiredFields) {
            if (!(field in responseData)) {
                return false;
            }
        }

        return true;
    }

    // eslint-disable-next-line class-methods-use-this
    protected transformRawResponseData(responseData: ServerJsonRpcResponse<RESP>): JsonRpcResponse<RESP> {
        const response: JsonRpcResponse<RESP> = {
            id: null,
            jsonrpc: '2.0'
        };

        if (typeof responseData.result === 'object' && responseData.result && 'error' in responseData.result) {
            response.error = responseData.result.error;
            return response;
        }

        // @ts-ignore
        response.result = responseData.result;
        return response;
    }
}
